import { SourcesAuthType } from '@api/types.gen';

import { FormControl } from '@@/form-components/FormControl';
import { RadioGroup } from '@@/RadioGroup/RadioGroup';

const authTypeOptions = [
  { value: SourcesAuthType.AUTH_TYPE_BASIC, label: 'Basic' },
  { value: SourcesAuthType.AUTH_TYPE_TOKEN, label: 'Token' },
] as const;

type Props = {
  value: SourcesAuthType;
  onChange: (authorizationType: SourcesAuthType) => void;
};

export function AuthTypeSelector({ value, onChange }: Props) {
  return (
    <FormControl inputId="authorizationType" label="Authorization type">
      <RadioGroup
        options={authTypeOptions}
        selectedOption={value}
        onOptionChange={onChange}
        name="authorizationType"
      />
    </FormControl>
  );
}
